var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from 'react';
import { getFGsWithDeliveryTrackerReturnWindow } from '../utils/returns/returns-fg-helper';
import { GetOrderDetailsAPI } from '../api/oms/order-details';
import { getOrderType } from '../utils/order-details/OrderDetailsUtils';
import { GetDeliveryTrackerInfo } from './delivery-tracker-hooks';
import { useSetOrderDetailsCache } from './order-details-hooks/useSetOrderDetailsCache';
import { FeatureSwitches } from '../constants/feature-switches';
import { useExperienceContext } from './useContexts';
export var RequestOrderDetailsData = function (customerType, customerRole, requestParams, setOrderDetailsData, requestOriginatedFrom, channel) {
    var orderNumber = requestParams.orderNumber, salesDate = requestParams.salesDate, storeNumber = requestParams.storeNumber, transactionId = requestParams.transactionId, registerNumber = requestParams.registerNumber, orderIndex = requestParams.orderIndex, customerAccountId = requestParams.customerAccountId;
    var request;
    // only currently handles b2b, b2c logic will come after cards are integrated
    if (customerType === 'b2b') {
        if (getOrderType(orderNumber) === 'INSTORE') {
            request = {
                orderDetailsRequest: {
                    searchType: 'instore',
                    registerNumber: registerNumber,
                    salesDate: salesDate,
                    storeNumber: storeNumber,
                    transactionId: transactionId,
                    customerAccountId: customerAccountId,
                    groupAndSortBy: {
                        groupBy: 'fulfillmentType',
                        filterResponse: true,
                    },
                    requestOriginatedFrom: requestOriginatedFrom,
                },
                orderIndex: orderIndex,
            };
        }
        else {
            request = {
                orderDetailsRequest: {
                    searchType: 'online',
                    orderNumber: orderNumber,
                    customerAccountId: customerAccountId,
                    groupAndSortBy: {
                        groupBy: 'fulfillmentType',
                        filterResponse: true,
                    },
                    requestOriginatedFrom: requestOriginatedFrom,
                },
                orderIndex: orderIndex,
            };
        }
    }
    else if (getOrderType(orderNumber) === 'INSTORE') {
        // change above to aut or guest
        // auth
        request = {
            orderDetailsRequest: {
                searchType: 'online',
                orderNumber: orderNumber,
                requestOriginatedFrom: requestOriginatedFrom,
            },
            orderIndex: orderIndex,
        };
    }
    else {
        // guest
        request = {
            orderDetailsRequest: {
                searchType: 'online',
                orderNumber: orderNumber,
                requestOriginatedFrom: requestOriginatedFrom,
                // emailId,
            },
            orderIndex: orderIndex,
        };
    }
    GetOrderDetailsData(customerType, customerRole, request, setOrderDetailsData, channel);
};
// B2B
var GetOrderDetailsData = function (customerType, customerRole, requestData, setOrderDetailsData, channel) {
    GetOrderDetailsAPI(customerType, customerRole, requestData, channel).then(function (response) {
        var _a;
        response.data.traceId = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.traceid;
        return setOrderDetailsData(response.data);
    });
};
export var GetOrderDetailsInfo = function (customerType, customerRole, request, localDelivery) {
    var channel = useExperienceContext().channel;
    var enableDeliveryTrackerReturnChanges = FeatureSwitches.enableDeliveryTrackerReturnChanges;
    var _a = useState(undefined), orderDetailsData = _a[0], setOrderDetailsData = _a[1];
    var _b = useState(undefined), orderDetailsError = _b[0], setOrderDetailsError = _b[1];
    var _c = useState(false), orderDetailsLoaded = _c[0], setOrderDetailsLoaded = _c[1];
    var _d = useState(false), deliveryTrackerLoaded = _d[0], setDeliveryTrackerLoaded = _d[1];
    // Initialize cache hook - this will be updated throughout the lifecycle
    useSetOrderDetailsCache({
        data: orderDetailsData,
        error: orderDetailsError,
        loaded: orderDetailsLoaded,
    });
    useEffect(function () {
        var fetchOrderDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, error_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, 3, 4]);
                        return [4 /*yield*/, GetOrderDetailsAPI(customerType, customerRole || '', request, channel, localDelivery)];
                    case 1:
                        response = _b.sent();
                        response.data.traceId = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.traceid;
                        setOrderDetailsData(response.data);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _b.sent();
                        setOrderDetailsError(error_1);
                        return [3 /*break*/, 4];
                    case 3:
                        setOrderDetailsLoaded(true);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchOrderDetails();
    }, []);
    useEffect(function () {
        if (orderDetailsLoaded && orderDetailsData) {
            GetDeliveryTrackerInfo(orderDetailsData)
                .then(function (deliveryTrackingData) {
                // Attempt to get delivery tracking data and deep copy into order details
                var deliveryTrackerData = deliveryTrackingData;
                if (enableDeliveryTrackerReturnChanges && deliveryTrackerData) {
                    // Update OMS's lineItem returnWindowEndDate with delivery tracker's returnWindowEndDate for any STH fulfillment group
                    var updatedFulfillmentGroups = getFGsWithDeliveryTrackerReturnWindow(deliveryTrackerData.fulfillmentGroups);
                    setOrderDetailsData(__assign(__assign({}, deliveryTrackerData), { fulfillmentGroups: updatedFulfillmentGroups }));
                }
                else {
                    setOrderDetailsData(deliveryTrackerData);
                }
            })
                .catch(function (err) {
                // eslint-disable-next-line no-console
                console.error('Error fetching delivery tracker data', err);
            })
                .finally(function () {
                setDeliveryTrackerLoaded(true);
            });
        }
    }, [orderDetailsLoaded]);
    return {
        orderDetailsData: orderDetailsData,
        orderDetailsError: orderDetailsError,
        orderDetailsLoaded: orderDetailsLoaded,
        deliveryTrackerLoaded: deliveryTrackerLoaded,
    };
};
